export enum CheckoutTypes {
  Default = '',
  Membership = 'Membership',
  Magazine = 'Magazine',
  Upgrade = 'Upgrade'
}
